module.exports = __webpack_public_path__ + "static/media/Ujieres.1540d18f.jpg";